import * as React from "react";
import * as Yup from "yup";
import { useApiService, useTl, useCrudApi } from "../../../../hooks";
import { useReferential } from "../../../../hooks/useReferential";
import { ERoutes } from "../../../../ERoutes";
import { PermissionApi, UserProfileActionGridDto } from "../../../../api";
import { ETLCodes } from "../../../../locales";
import { PageBase, SmallFormGenerator } from "../../../../components";
import {
  FieldSet,
  FieldGroup,
  FGSelectInput,
  FGCustomPanel,
} from "nsitools-react";
import { PermissionGrid } from "./PermissionGrid";
export interface IPermissionListPageProps {}

export const PermissionListPage: React.FunctionComponent<IPermissionListPageProps> = (
  props
) => {
  const { t } = useTl();
  const api = useApiService(PermissionApi);
  const [userProfiles, upLoading] = useReferential(
    (a) => a.getUserProfiles(),
    true,
    [],
    true
  );

  const { data, saving, saveItem } = useCrudApi(
    {
      getApiFn: () => {
        return new UserProfileActionGridDto({
          userProfileId:
            userProfiles && userProfiles.length > 0
              ? +userProfiles[0].value
              : 0,
        });
      },
      saveApiFn: (d) => api.savePermission(d),
      onSavedRoute: () => `${ERoutes.permission}`,
      deleteApiFn: () => {},
    },
    [userProfiles]
  );
  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({
      idaccesLevel: Yup.number().required(t(ETLCodes.Required)),
    });
  }, [t]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.Permission), route: ERoutes.permission },
      ]}
      withCard
    >
      <FieldSet title={t(ETLCodes.Permission)}>
        {data && (
          <SmallFormGenerator
            initialValues={data}
            onSubmit={saveItem}
            showColons
            editMode
            validationSchema={FormSchema}
            saving={saving}
            formatDate="DD-MM-YYYY"
            hideButtons
            enableDirtyCheck={false}
          >
            <FieldGroup columns={2}>
              <FGSelectInput
                label={t(ETLCodes.Profile)}
                items={userProfiles}
                loading={upLoading}
                name="userProfileId"
              />
            </FieldGroup>
            <FieldGroup>
              <FGCustomPanel>
                {(ctx) => {
                  return (
                    <PermissionGrid
                      userProfileId={ctx.formik.values.userProfileId}
                    />
                  );
                }}
              </FGCustomPanel>
            </FieldGroup>
          </SmallFormGenerator>
        )}
      </FieldSet>
    </PageBase>
  );
};
